import moment from 'moment';
import * as _ from 'lodash';

export const formatDate = (input) => (!input ? '' : moment(input).format('DD/MM/YYYY'));
export const convertUtcToLocalTime = (date, format) => {
  if (_.isEmpty(date)) {
    return "";
  } else {
    const localDate = moment.utc(date).zone('+0700').format(format);
    return localDate;
  }
};